module.exports = __webpack_public_path__ + "static/media/larc_open.8bae048a.jpg";